// Movie data with runtime in minutes
export const movies = [
  {
    id: 1,
    title: "Dune: Part Two",
    year: 2024,
    runtime: 166,
    color: "bg-orange-600"
  },
  {
    id: 2,
    title: "Oppenheimer",
    year: 2023,
    runtime: 180,
    color: "bg-gray-800"
  },
  {
    id: 3,
    title: "Spider-Man: Across the Spider-Verse",
    year: 2023,
    runtime: 140,
    color: "bg-red-700"
  },
  {
    id: 4,
    title: "The Batman",
    year: 2022,
    runtime: 176,
    color: "bg-black"
  },
  {
    id: 5,
    title: "Everything Everywhere All at Once",
    year: 2022,
    runtime: 139,
    color: "bg-purple-800"
  },
  {
    id: 6,
    title: "Top Gun: Maverick",
    year: 2022,
    runtime: 130,
    color: "bg-orange-700"
  },
  {
    id: 7,
    title: "Knives Out",
    year: 2019,
    runtime: 130,
    color: "bg-indigo-800"
  },
  {
    id: 8,
    title: "Parasite",
    year: 2019,
    runtime: 132,
    color: "bg-green-800"
  }
];

